<div>
  <div class="breadcrumbs">
      <button class="back-button" (click)="navigateToDashboard()">
          <mat-icon>arrow_back_ios</mat-icon>
          <span class="breadcrumb-text">{{ this.qbuiltConstants.breadcrumbTextHome }}</span>
      </button>
      <span class="breadcrumb-text">{{ this.qbuiltConstants.breadcrumbChecklistHome }}</span>
  </div>

  <content-panel class="container">
    <panel-header heading="{{this.qbuiltConstants.checklistTableTitle}}">
      <!-- <button class="headerButton" mat-icon-button>
      <mat-icon>filter_alt</mat-icon>
    </button> -->
    <button class="headerButton" mat-icon-button [disabled]="dataSource.data.length" (click)="newChecklist()">
      <mat-icon>add</mat-icon>
    </button>
  </panel-header>

  <panel-body>
    <div>
      <section>
        <table mat-table [dataSource]="dataSource.data.length > 0 ? dataSource : emptyData" class="mat-elevation-z8">
          <!-- Actions Column -->
          <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let row" class="actions-column">
              <button class="actions-button" mat-icon-button (click)="editChecklist(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <!-- Will be used later -->
              <!-- <button class="actions-button" mat-icon-button (click)="deleteChecklist(row)">
              <mat-icon>delete</mat-icon>
            </button>
            <button class="actions-button" mat-icon-button (click)="copyChecklist(row)">
              <mat-icon>file_copy</mat-icon>
            </button> -->
          </td>
        </ng-container>

        <!-- Checklist Column -->
        <ng-container matColumnDef="ChecklistName">
          <th mat-header-cell *matHeaderCellDef class="column-style"><b> Checklist Name </b></th>
          <td mat-cell *matCellDef="let element" class="column-style"> {{element.Name}} </td>
        </ng-container>

        <!-- Comments Column -->
        <ng-container matColumnDef="Comments">
          <th mat-header-cell *matHeaderCellDef ><b> Comments </b></th>
          <td mat-cell *matCellDef="let element" class="comment-style" [matTooltip]="element.Comment"> {{element.Comment}} </td>
        </ng-container>

        <!-- CreatedOn Column -->
        <ng-container matColumnDef="CreatedOn">
          <th mat-header-cell *matHeaderCellDef class="column-style"><b> Creation Date </b> </th>
          <td mat-cell *matCellDef="let element" class="column-style"> {{formatDate(element.CreatedOn)}} </td>
        </ng-container>

        <!-- Active Column -->
        <ng-container matColumnDef="Active">
          <th mat-header-cell *matHeaderCellDef class="column-style"><b> Active </b></th>
          <td mat-cell *matCellDef="let element" class="column-style">
            @if (element.IsActive) {
              <span class="chip-styling active">{{activeTrue}}</span>
            } @else {
              <span class="chip-styling inactive">{{activeFalse}}</span>
            }
          </td>
        </ng-container>

        <tr class="mat-row" matColumnDef="empty-row">
          <td *matCellDef="let element" class="mat-cell" [attr.colspan]="tableColumns.length">{{ this.qbuiltConstants.checklistTableNew }}</td>
        </tr>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns:  dataSource.data.length > 0 ? tableColumns : ['empty-row'];"
        ></tr>
      </table>
    </section>
  </div>
  </panel-body>
  <!-- <mat-paginator
  [pageSizeOptions]="paginatorOptions.pageSizeOptions"
  [pageSize]="paginatorOptions.pageSize"
  [length]="paginatorOptions.pageLength"
  [pageIndex]="materialPageIndex"
  [showFirstLastButtons]="paginatorOptions.showFirstLastButtons"
  >
  </mat-paginator> -->
  </content-panel>
</div>